"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _envConstants = require("../../env-constants");
var _Card = _interopRequireDefault(require("../Card/Card"));
var _CardSlider = _interopRequireDefault(require("../CardSlider/CardSlider"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Instagram = function Instagram(_ref) {
  var noLink = _ref.noLink,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'See our social' : _ref$title,
    _ref$socialFeed = _ref.socialFeed,
    socialFeed = _ref$socialFeed === void 0 ? [] : _ref$socialFeed;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-bottom-lg"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-ls-sm text-xxl"
  }, title || 'See our social')), /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], null, socialFeed.map(function (post) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: JSON.stringify(post)
    }, noLink ? /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      icon: post.title ? 'tiktok' : 'instagram',
      template: "ImageCard",
      size: "xs",
      bgImage: {
        url: post.cover_image_url ? post.cover_image_url : post.thumbnail_url ? post.thumbnail_url : post.media_url,
        alt: post.title ? post.title : post.caption
      }
    }) : /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: post.embed_link ? post.embed_link : "https://www.instagram.com/".concat(_envConstants.ENV.INSTAGRAM_USER, "/"),
      external: true
    }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      icon: post.title ? 'tiktok' : 'instagram',
      template: "ImageCard",
      size: "xs",
      bgImage: {
        url: post.cover_image_url ? post.cover_image_url : post.thumbnail_url ? post.thumbnail_url : post.media_url,
        alt: post.title ? post.title : post.caption
      }
    })));
  })), _envConstants.ENV.SITE !== 'tyw' && !noLink && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-top-lg",
    text: "Follow us on Instagram",
    icon: "instagram",
    link: "https://www.instagram.com/".concat(_envConstants.ENV.INSTAGRAM_USER, "/"),
    buttonType: _constants.BUTTON_TYPES.INSTAGRAM,
    external: true
  }));
};
var _default = exports["default"] = Instagram;